var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWHomeV(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6793 16.9999V26.5358H7.32188V16.9999C7.32188 16.5857 6.98609 16.2499 6.57188 16.2499H5.059C4.77877 16.2499 4.6417 15.8941 4.85655 15.7063C4.86406 15.6998 4.87144 15.693 4.87868 15.6862L14.9142 6.18294L14.9144 6.18279C15.5234 5.60574 16.4768 5.60574 17.0859 6.18279L17.086 6.18292L27.1207 15.6862C27.1282 15.6932 27.1358 15.7002 27.1436 15.7069C27.3573 15.8932 27.2225 16.2499 26.9405 16.2499H25.4293C25.0151 16.2499 24.6793 16.5857 24.6793 16.9999Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3249 26.5327V22.1398C13.3249 20.6606 14.5243 19.4612 16.0035 19.4612C17.4828 19.4612 18.6821 20.6606 18.6821 22.1398V26.5327H13.3249Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWHomeV);
export default __webpack_public_path__ + "static/media/W_Home_V.17e7fccd3b88f1e4c7bf01d9c8060de5.svg";
export { ForwardRef as ReactComponent };